// extracted by mini-css-extract-plugin
module.exports = {"close":"modal_close__15qrp"};